export default __webpack_public_path__ + "static/media/userIcon.4b779269.png";